import Input from '../../form/Input';
import BigButton from '../../button/BigButton';
import { useCallback, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useCustomerStore } from '../../../store/useCustomer';

const PasswordModal = ({
  id,
  setId,
  isOpen,
  setIsOpen,
}: {
  id: string;
  setId: React.Dispatch<React.SetStateAction<string>>;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { updateCustomerPassword } = useCustomerStore();

  const [password, setPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [newPasswordCheck, setNewPasswordCheck] = useState<string>('');
  const onChangePassword = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setPassword(value);
    },
    []
  );
  const onChangeNewPassword = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setNewPassword(value);
    },
    []
  );
  const onChangeNewPasswordCheck = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setNewPasswordCheck(value);
    },
    []
  );

  // 비밀번호 변경
  const onClickChangePassword = useCallback(() => {
    if (newPassword !== newPasswordCheck) {
      return toast.warn('새 비밀번호가 일치하지 않습니다.');
    }

    // 비밀번호 유효성 검사 (8자 이상, 대문자, 소문자, 숫자 포함)
    if (newPassword.length < 8) {
      return toast.warn('비밀번호는 8자 이상이어야 합니다.');
    }
    if (!/[A-Z]/.test(newPassword)) {
      return toast.warn('비밀번호에 대문자가 포함되어야 합니다.');
    }
    if (!/[a-z]/.test(newPassword)) {
      return toast.warn('비밀번호에 소문자가 포함되어야 합니다.');
    }
    if (!/[0-9]/.test(newPassword)) {
      return toast.warn('비밀번호에 숫자가 포함되어야 합니다.');
    }

    const updatePasswordData: { loginPw: string } = {
      loginPw: newPassword,
    };

    const checkPasswordData: { loginId: string; loginPw: string } = {
      loginId: id,
      loginPw: password,
    };

    updateCustomerPassword(updatePasswordData, checkPasswordData);
    setIsOpen(false);
    setPassword('');
    setNewPassword('');
    setNewPasswordCheck('');
  }, [
    id,
    newPassword,
    newPasswordCheck,
    password,
    setIsOpen,
    updateCustomerPassword,
  ]);

  const onClickClose = useCallback(() => {
    setIsOpen(false);
    setNewPassword('');
    setNewPasswordCheck('');
  }, [setIsOpen]);

  // ESC key event handler
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClickClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClickClose]);

  return (
    <div
      style={{ display: isOpen ? 'flex' : 'none' }}
      className="session_expired_modal_bg"
    >
      <div className="session_expired_modal">
        <div className="session_expired_info">
          <h1 style={{ lineHeight: '34px', paddingBottom: 24 }}>
            비밀번호 변경
          </h1>
          <div style={{ padding: '16px 0px 8px 0px', fontSize: 20 }}>
            <b style={{ color: '#cb1301' }}>"{id}"</b>님의 비밀번호를
            변경합니다.
          </div>
          <span style={{ padding: '24px 0px 40px 0px', margin: 0 }}>
            비밀번호를 한번 더 확인해 주세요!
          </span>
          <Input
            value={password}
            onChange={onChangePassword}
            placeholder="기존 비밀번호"
            style={{ marginBottom: 20, fontFamily: 'sans-serif', letterSpacing: '0.1em' }}
            type="password"
          />
          <Input
            value={newPassword}
            onChange={onChangeNewPassword}
            placeholder="새 비밀번호"
            style={{ marginBottom: 8, fontFamily: 'sans-serif', letterSpacing: '0.1em' }}
            type="password"
          />
          <Input
            value={newPasswordCheck}
            onChange={onChangeNewPasswordCheck}
            placeholder="새 비밀번호 확인"
            style={{ marginBottom: 24, fontFamily: 'sans-serif', letterSpacing: '0.1em' }}
            type="password"
          />
          <BigButton
            type="submit"
            text="비밀번호 변경"
            onClick={onClickChangePassword}
          />
          <BigButton
            type="update"
            text="닫기"
            style={{ marginTop: 8 }}
            onClick={onClickClose}
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
